
import './App.css';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useEffect } from 'react';
import LoginPage from './logincomponent/LoginPage'
import SurveryForm from './uicomponent/surveyform';
import ResultsPage from './resultcomponent/ResultPage'
import SummaryPage from './summarycomponent/SummaryPage'
import LogoutPage from './logoutcomponent/logoutpage';


import AdminLogin from './admincomponent/AdminLogin'; 
import AdminDashboard from './admincomponent/AdminDashboard';

import AdminHome from "./admincomponent/AdminHome";
import UploadUsers from './admincomponent/UploadUsers';



import FeedbackDashboard from "./feedbackdashboard/FeedbackDashboard";

import FeedbackTypeSelection from './feedbackdashboard/FeedbackTypeSelection';

import CategoryAnalysis from './feedbackreports/CategoryAnalysis';
function App() {

  useEffect(() => {
  // Prevent back & forward navigation
  window.history.pushState(null, "", window.location.href);

  const handlePopState = () => {
    window.history.pushState(null, "", window.location.href);
  };

  window.addEventListener("popstate", handlePopState);

  return () => {
    window.removeEventListener("popstate", handlePopState);
  };
}, []);

  return (
    <Router>
    <div className="App">
  
    
      <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/surveyform" element={<SurveryForm />} />
      <Route path="/results" element={<ResultsPage />} />
      <Route path="/summary" element={<SummaryPage />} />
      <Route path="/logout" element={<LogoutPage />} />


      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} /> 
      <Route path="/admin/home" element={<AdminHome />} /> 
      <Route path="/admin/uploadusers" element={<UploadUsers />} />  
  
    
       <Route path="/dashboard" element={<FeedbackDashboard />} />
<Route path="/select-feedback-type" element={<FeedbackTypeSelection/>} />
       
      <Route path="/catanalysis" element={<CategoryAnalysis userId={240}/>} />
    </Routes>
   
      </div>
  
      </Router>
    );
}

export default App;
